import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API, { getAuthConfig } from "../services/api";

function PassLookup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [pass, setPass] = useState(null);

  const handleSearch = async () => {
    if (!email) {
      alert("Please enter visitor email");
      return;
    }

    try {
      setLoading(true);
      setPass(null);
      const res = await API.get(`/pass/view?email=${encodeURIComponent(email)}`, getAuthConfig());
      setPass(res.data);
    } catch (err) {
      setPass(null);
      alert(err.response?.data?.message || "Pass not found");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="mx-auto max-w-2xl rounded-xl border border-gray-200 bg-white p-8 shadow-lg">
        <div className="mb-6 flex items-center justify-between gap-3">
          <h1 className="text-2xl font-bold text-gray-800">Pass Lookup</h1>
          <button onClick={() => navigate("/dashboard")} className="text-sm font-medium text-blue-600 underline">
            Back
          </button>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row">
          <input
            className="flex-1 rounded-lg border p-3"
            placeholder="Visitor email (example@gmail.com)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            onClick={handleSearch}
            disabled={loading}
            className="rounded-lg bg-blue-600 px-6 py-3 font-bold text-white hover:bg-blue-700 disabled:bg-gray-400"
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        {!pass && (
          <p className="mt-6 text-sm text-gray-500">
            Tip: use this after the visitor is approved, scheduled, and the pass is issued.
          </p>
        )}

        {pass && (
          <div className="mt-8 rounded-xl border border-gray-200 bg-gray-50 p-5">
            <p className="text-lg font-semibold text-gray-800">{pass.name}</p>
            <p className="text-sm text-gray-600">{pass.email}</p>
            <p className="mt-2 text-sm text-gray-700">
              <span className="font-semibold">Status:</span> {pass.status}
            </p>
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Visit:</span>{" "}
              {pass.isScheduled ? `${pass.visitDate} at ${pass.visitTime}` : "Not scheduled"}
            </p>

            <div className="mt-4">
              {pass.passUrl ? (
                <a
                  href={pass.passUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block rounded-lg bg-green-600 px-5 py-3 font-bold text-white hover:bg-green-700"
                >
                  Open / Download Pass PDF
                </a>
              ) : (
                <p className="text-sm text-gray-600">Pass is not issued yet.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PassLookup;

